module.exports = __webpack_public_path__ + "img/church.2c7fd33f.svg";